import { Button, Group, Stack, Text, Title } from '@mantine/core'
import { COLORS } from '../../../utils/constants'

export interface FootTrafficOption {
  value: string
  label: string
  range: string
}

const footTrafficOptions: FootTrafficOption[] = [
  {
    value: 'low',
    label: 'Low',
    range: '0–50',
  },
  {
    value: 'moderate',
    label: 'Moderate',
    range: '51–150',
  },
  {
    value: 'steady',
    label: 'Steady',
    range: '151–300',
  },
  {
    value: 'busy',
    label: 'Busy',
    range: '301–600',
  },
  {
    value: 'high',
    label: 'High',
    range: '601+',
  },
]

interface FootTrafficStepProps {
  footTraffic: string | null | undefined
  updateFootTraffic: (footTraffic: string) => void
}

const FootTrafficStep = ({
  footTraffic,
  updateFootTraffic,
}: FootTrafficStepProps) => {
  return (
    <Stack align='center' pb='lg' ml='sm' mr='sm' w='100%'>
      <Title ta='center' fz={16} fw={300} pb={32}>
        Select the average number of visitors your location typically sees in a
        day. This helps advertisers understand the reach of their ads.
      </Title>
      <Group gap='md' justify='center' wrap='wrap'>
        {footTrafficOptions.map((option) => (
          <Button
            key={option.value}
            variant={footTraffic === option.value ? 'filled' : 'outline'}
            size='lg'
            bg={footTraffic === option.value ? COLORS.LightGreen : 'white'}
            c={footTraffic === option.value ? 'white' : 'black'}
            onClick={() => updateFootTraffic(option.value)}
            styles={{
              root: {
                width: '120px',
                height: '120px',
                padding: '12px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                borderColor:
                  footTraffic === option.value ? COLORS.LightGreen : 'black',
              },
              label: {
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '8px',
              },
            }}
          >
            <Text
              fw={600}
              size='md'
              c={footTraffic === option.value ? 'white' : 'black'}
            >
              {option.label}
            </Text>
            <Text
              size='sm'
              c={footTraffic === option.value ? 'white' : 'black'}
            >
              {option.range}
            </Text>
          </Button>
        ))}
      </Group>
    </Stack>
  )
}

export default FootTrafficStep
